/**
 * abilityVfxNami — Nami Q/W/E/R tide silhouettes (SPY-312).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

export function buildAquaPrison(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.5);
  const aqua = mat(THREE, spec.color || 0x22d3ee, 0.88);
  const foam = mat(THREE, 0xa5f3fc, 0.8);
  const bubble = new THREE.Mesh(new THREE.SphereGeometry(0.42 * s, 12, 10), aqua);
  bubble.position.y = 0.45 * s;
  group.add(bubble);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.35 * s, 0.75 * s, 20).rotateX(-Math.PI / 2),
    foam
  );
  ring.position.y = 0.05;
  group.add(ring);
  const drip = new THREE.Mesh(new THREE.ConeGeometry(0.1 * s, 0.3 * s, 6), foam);
  drip.position.y = 0.95 * s;
  group.add(drip);
  group.userData = { shape: 'aqua_prison' };
  return group;
}

export function buildEbbAndFlow(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1.2);
  const teal = mat(THREE, spec.color || 0x14b8a6, 0.88);
  const foam = mat(THREE, 0x99f6e4, 0.8);
  const orb = new THREE.Mesh(new THREE.SphereGeometry(0.28 * s, 10, 10), teal);
  orb.position.y = 0.5 * s;
  group.add(orb);
  const wave = new THREE.Mesh(new THREE.TorusGeometry(0.38 * s, 0.05 * s, 8, 16), foam);
  wave.rotation.x = Math.PI / 2;
  wave.position.y = 0.35 * s;
  group.add(wave);
  const spark = new THREE.Mesh(new THREE.SphereGeometry(0.1 * s, 8, 8), foam);
  spark.position.set(0.32 * s, 0.75 * s, 0);
  group.add(spark);
  group.userData = { shape: 'ebb_and_flow' };
  return group;
}

export function buildTidecallerBlessing(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.65 * (spec.scale || 1.3);
  const aqua = mat(THREE, spec.color || 0x38bdf8, 0.85);
  const foam = mat(THREE, 0xe0f2fe, 0.8);
  const core = new THREE.Mesh(new THREE.SphereGeometry(0.3 * s, 10, 10), aqua);
  core.position.y = 0.55 * s;
  group.add(core);
  const halo = new THREE.Mesh(new THREE.TorusGeometry(0.42 * s, 0.05 * s, 8, 16), foam);
  halo.rotation.x = Math.PI / 2;
  halo.position.y = 0.55 * s;
  group.add(halo);
  const spark = new THREE.Mesh(new THREE.SphereGeometry(0.1 * s, 8, 8), foam);
  spark.position.set(0, 0.95 * s, 0);
  group.add(spark);
  group.userData = { shape: 'tidecaller_blessing' };
  return group;
}

export function buildTidalWave(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.8 * (spec.scale || 1.6);
  const deep = mat(THREE, spec.color || 0x0369a1, 0.9);
  const foam = mat(THREE, 0x7dd3fc, 0.85);
  const wall = new THREE.Mesh(new THREE.BoxGeometry(0.25 * s, 0.7 * s, 1.3 * s), deep);
  wall.position.y = 0.4 * s;
  group.add(wall);
  const crest = new THREE.Mesh(new THREE.ConeGeometry(0.18 * s, 0.4 * s, 6), foam);
  crest.position.set(0, 0.9 * s, 0.4 * s);
  group.add(crest);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.25 * s, 0.7 * s, 18).rotateX(-Math.PI / 2),
    foam
  );
  ring.position.y = 0.05;
  group.add(ring);
  group.userData = { shape: 'tidal_wave' };
  return group;
}
